import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  private _pageTitle = signal<string>('');

  pageTitle = this._pageTitle.asReadonly();

  setPageTitle(title: string): void {
    this._pageTitle.set(title);
  }

  clearPageTitle(): void {
    this._pageTitle.set('');
  }
}
